module.exports = __webpack_public_path__ + "static/img/Sam-Walker.fadc60b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sam-Walker.jpg
// module id = x7Ia
// module chunks = 0